/**
 * @generated SignedSource<<b6112e46b93cbf2c6ed0608ae85e8c9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SudoDeleteEverythingMutationInput = {
  clientMutationId?: string | null;
};
export type SudoDeleteEverythingMutation$variables = {
  input: SudoDeleteEverythingMutationInput;
};
export type SudoDeleteEverythingMutation$data = {
  readonly sudoDeleteEverything: {
    readonly clientMutationId: string | null;
  } | null;
};
export type SudoDeleteEverythingMutation = {
  variables: SudoDeleteEverythingMutation$variables;
  response: SudoDeleteEverythingMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SudoDeleteEverythingMutationPayload",
    "kind": "LinkedField",
    "name": "sudoDeleteEverything",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SudoDeleteEverythingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SudoDeleteEverythingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6e9728cd5f2a43b7f5ddac1312cc7613",
    "id": null,
    "metadata": {},
    "name": "SudoDeleteEverythingMutation",
    "operationKind": "mutation",
    "text": "mutation SudoDeleteEverythingMutation(\n  $input: SudoDeleteEverythingMutationInput!\n) {\n  sudoDeleteEverything(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c2368bf0a209439285b722aa26ab73c";

export default node;
